import { Pencil } from "lucide-react";
import { forwardRef } from "react";
import { Button } from "../../../../../../shared/components/button/Button";

const ObjectivesTrackerEditTriggerButton = forwardRef((props, ref) => {
  return (
    <Button
      {...props}
      aria-haspopup="true"
      size="icon"
      variant="ghost"
      ref={ref}
    >
      <Pencil className="h-4 w-4" />
      <span className="sr-only">Toggle menu</span>
    </Button>
  );
});

export default ObjectivesTrackerEditTriggerButton;
